import { $authHost } from "../index";

export const getInfosAPI = async () => {
    const { data } = await $authHost.get(`/api/dashboard/get/infos`)
    return data;
}